import React, { Component } from 'react';
import Services, { Service } from '../common/Services';
import Section from '../common/Section';
import postscribe from 'postscribe';

import './VaillantLightBox.css';

export default class Heizung extends Component {
  componentDidMount() {
    try {
      window.galleryHeizung();
      window.adjustSubmenu();
      postscribe('#VaillantLightBox', '<script src ="https://www.vaillantpartner.de/teaser/index.php?id=pailer&p=1"></script>');
    }
    catch (err) {
      console.log(err);
    }
  }

  render() {
    return (
      <div className="Heizung">
        <div id="content" className="container" role="main">
        <div id="Planung u. Angebot" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-1" description="HTML"><a name="unser-service"></a>
                <div className="section">
                  <div className="services">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h1 className="section-heading">Planung Ihrer Heizungsanlage</h1>
                        <p>Sie interessieren sich für eine neue Heizungsanlage? In 3 Schritten zu Ihrer individuellen Planung:</p>
                      </div>
                    </div>
                    <div className="row text-center">
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-file-signature fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">1. DATENAUFNAHME</h4>
                        <p className="text-muted">Wir möchten Sie gerne umfassend fachlich beraten und benötigen noch weitere Details. Beantworten Sie hierzu unverbindlich unsere Fragen zu Ihrer aktuellen Situation und Ihren Anforderungen. 
                          Unser Formular finden Sie über den folgenden <a href="https://form.jotform.com/241623490861053" target="blank">Link Anfrage Heizung (externe Webseite)</a><i className="fa-solid fa-up-right-from-square"></i>: 
                          <p></p>
                          <a href="https://form.jotform.com/241623490861053" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage Heizung</button>
                          </a>
                          <p></p>
                          </p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-search fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">2. PRÜFUNG IHRER DATEN</h4>
                        <p className="text-muted">Wie geht es für Sie weiter? Nun sind wir dran! Im nächsten Schritt prüfen wir Ihre Daten. Aufgrund der aktuell hohen Nachfrage kommt es vereinzelt zu längeren Bearbeitungszeiten.</p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-3x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-calendar fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">3. Termin und Beratung</h4>
                        <p className="text-muted">Nach der Prüfung wird die Planung konkreter. Wir klären weitere Details telefonisch und sprechen mit Ihnen über ein grobes Budget für Ihr Projekt. Anschließend sprechen wir über die konkrete Projektierung und Auslegung Ihrer neuen Heizungsanlage.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
          <div id="Unser Service" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-1" description="HTML"><a name="unser-service"></a>
                <div className="section bg-light-gray">
                  <div className="services">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h1 className="section-heading">UNSER SERVICE</h1>
                        <hr></hr>
                      </div>
                    </div>
                    <div className="row text-center">
                      <div className="col-md-4">
                        <span className="fa-stack fa-5x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-wrench fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">24h Notdienst, Kundendienst und Wartungsservice</h4>
                        <p className="text-muted">Ihre Heizung ist auf Störung und Ihre Wohnung ist kalt? Für unsere Bestandskunden rücken unsere Techniker auch außerhalb der üblichen Arbeitszeiten, am Wochenende oder an Feiertagen aus. <br></br>Genauso wie Ihr Auto eine jährliche Inspektion
                          benötigt, muss auch Ihre Heizungsanlage regelmäßig gewartet werden.<br></br>Sprechen Sie
                          uns an, wir beraten Sie gerne. Folgend finden Sie unseren Link zum Formular <a href="https://form.jotform.com/241891698027367" target="blank">Anfrage Wartung Heizung (externe Webseite)</a><i className="fa-solid fa-up-right-from-square"></i>: 
                          <p></p>
                          <a href="https://form.jotform.com/241891698027367" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage Wartung Heizung</button>
                          </a>
                          <p></p>
                          <a href="mailto:info@pailer.com">info@pailer.com</a> | <a href="tel:+497232372506">07232 / 37 25 06</a></p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-5x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-pencil fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">Individuelle Planung Beratung, Wärmebedarfsrechnung</h4>
                        <p className="text-muted">Sie Planen einen Neubau oder möchten Ihre Heizungsanlage komplett
                          umbauen? In Sachen Planung und Beratung sind wir Ihr kompetenter Ansprechpartner.
                          Mit Blick auf die Energiesparverordnung (EnEv) finden wir mit Ihnen gemeinsam das
                          passende Heizsystem für Ihr Zuhause: kostenreduzierend im Betrieb, umweltschonend
                          und zukunftssicher.</p>
                      </div>
                      <div className="col-md-4">
                        <span className="fa-stack fa-5x">
                          <i className="fa fa-circle fa-stack-2x text-primary"></i>
                          <i className="fa fa-home fa-5 fa-stack-1x fa-inverse"></i>
                        </span>
                        <h4 className="service-heading">Heizungsmodernisierung</h4>
                        <p className="text-muted">Sie denken darüber nach Energiekosten zu sparen und möchten Ihre
                          in die Jahre gekommene Heizungsanlage modernisieren? Wir unterstützen Sie bei Ihrem
                          Modernisierungsvorhaben. Anhand einer individuellen Beratung finden wir für Sie eine
                          innovative Heizung die zu Ihnen und Ihrem Budget passt.<br></br>Folgend finden Sie unseren Link zum Formular <a href="http://neue.heizung.pailer.com" target="blank">Anfrage Heizung (externe Webseite)</a><i className="fa-solid fa-up-right-from-square"></i>: 
                          <p></p>
                          <a href="http://neue.heizung.pailer.com" target="blank">
                            <button type="button" class="btn btn-primary btn-sm">Zum Formular Anfrage Heizung</button>
                          </a>
                          <p></p>
                          <a href="mailto:info@pailer.com">info@pailer.com</a> | <a href="tel:+497232372506">07232 / 37 25 06</a></p>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
          <div className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-2" description="HTML">
                <a id="Wärmepumpe" name="waermepumpe"></a>
                <div className="section">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="text-center">
                        <h1>Wärmepumpe</h1>
                        <hr className="gray"></hr>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="same-height shadowbox-gray shadow-border-black-top">
                      <div className="row">
                        <div className="col-md-12 text-center">
                          <h2>Wärmepumpen von Vaillant</h2>
                          <h4>Umweltwärme effizient nutzen</h4>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <img src="files/heizung/vaillant/waermepumpe.JPG" className="img-responsive" alt="Firma Kurt Pailer ist Vaillant Kompetenzpartner" />
                          <p className="text-muted">Vaillant Luft/Wasser-Wärmepumpe aroTHERM plus</p>
                        </div>
                        <div className="col-md-12">
                        <p>Erneuerbare Energie aus Luft, Grundwasser sowie der Erde ist um uns herum. Wärmepumpen verwandeln diese Energie in Wärme, wofür Sie grob 25 % Strom als Energie benötigen. Kombiniert mit einer Photovoltaik erzeugt man einen Teil des benötigen Strom mit Sonnenenergie.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row same-height-box">
                    <div className="col-md-6">
                      <div className="same-height shadowbox-white shadow-border-top">
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <h4>Wärmepumpe Funktion</h4>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">                            
                            <p className="text-muted">Entdecken Sie in nur 100 Sekunden die Faszination einer
                              Wärmepumpe</p>
                              <a href="https://youtu.be/6KnsoFLBYnk" target="blank">Youtube Video: Faszination Wärmepumpe | Vaillant (externe Webseite)</a>                                                      
                              <p></p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p>Eine Wärmepumpe kann man mit dem Prinzip eines Schnellkochtopfs vergleichen: Wasser wird zum Kochen und schließlich zum Verdampfen gebracht. Da der Dampf nicht entweichen kann, nimmt der Druck zu – und die Temperatur des Wasserdampfes steigt. Statt Wasser wird bei einer Wärmepumpe ein spezielles Kältemittel zum „Kochen“ gebracht. Der Siedepunkt des Kältemittels liegt bereits bei -40 °C. Mit einem Kompressor wird der Druck des verdampften Kältemittels weiter erhöht. Dadurch steigt die Temperatur des gasförmigen Kältemittels so stark an, dass selbst bei tiefen Außentemperaturen genug Wärme zum Heizen zur Verfügung steht. Sehen Sie selbst!</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
          <div id="kompetenzpartner" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div
              className="col col-md-12">
              <respond-html id="html-3" description="HTML"><a name="vaillant-kompetenzpartner"></a>
                <div className="section section bg-light-gray">
                  <div className="services">
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h1 className="section-heading">Wir sind Vaillant Kompetenzpartner!</h1>
                        <hr></hr>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        <img src="files/heizung/vaillant/vaillant_kompetenz_partner_logo.JPG" className="img-responsive" alt="Firma Kurt Pailer ist Vailant Kompetenzpartner" />
                      </div>
                      <div className="col-md-3">
                        Während der vergangenen Jahre haben wir unter Beweis gestellt, dass wir zu den besten Vaillant Partnern deutschlandweit gehören.
                        Wir freuen uns daher sehr, dass Vaillant uns erneut für weitere zwei Jahre zum Kompetenzpartner
                        ausgezeichnet hat.
                        <br></br><br></br> Mit uns an Ihrer Seite sind Sie als Kunde also bestens beraten. Sie können sich
                        auf unser Fachwissen verlassen! Ob Badsanierung, Heizungsmodernisierung oder Neubau,
                        wir beraten Sie gerne!<br></br><br></br>
                      </div>
                      <div className="col-md-3">
                        Vaillant Kompetenzpartner stehen für …<br></br><br></br>
                        <ul>
                          <li>Kundenorientierten Service</li>
                          <li>Kompetente Leistung</li>
                          <li>Große Innovationskraft</li>
                          <li>Gleichbleibend</li>
                          <li>hohe Qualität</li>
                          <li>Nachhaltigkeit</li>
                          <li>5Plus Sorglos Versprechen</li>
                        </ul>
                      </div>
                      <div className="col-md-3">
                        <img src="files/heizung/vaillant/kompetenz_partner.JPG" className="img-responsive" alt="Firma Kurt Pailer ist Vaillant Kompetenzpartner" />                        
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
          <Section>
            <div id="kpLightBox">
              <div id="VaillantLightBox"></div>
            </div>
          </Section>
          <div className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-2" description="HTML">
                <a id="Energieträger" name="energietraeger"></a>
                <div className="section  bg-light-gray">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="text-center">
                        <h1>Energieträger</h1>
                        <hr className="gray"></hr>
                      </div>
                    </div>
                  </div>
                  <div className="row same-height-box">
                    <div className="col-md-4">
                      <div className="same-height shadowbox-white shadow-border-top">
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <h2>Wärmepumpe</h2>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p className="text-muted">Entdecken Sie in nur 100 Sekunden die Faszination einer
                              Wärmepumpe</p>
                              <a href="https://youtu.be/6KnsoFLBYnk" target="blank">Youtube Video: Faszination Wärmepumpe | Vaillant (externe Webseite)</a>                                                      
                              <p></p>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p>Wäre es nicht schön, wenn Sie den überwiegenden Teil der Energie für Ihre
                              Wärme ganz ohne fossile Rohstoffe gewinnen könnten? Mit Wärmepumpensystemen
                              machen Sie sich die gespeicherte Wärme Ihrer Umwelt nutzbar. Die Systeme
                              der Serie geoTHERM von Vaillant fördern die Energie aus der Erde direkt in
                              Ihren Heizkreislauf, sodass nur 25 % der Energie zusätzlich eingebracht werden
                              müssen. Evtl. auch ohne größere bauliche Veränderungen können Sie die innovative
                              Wärmepumpentechnik für Ihr Zuhause nutzen. Denn einer Luft-/Wasserwärmepumpe
                              reicht sogar die Energie aus der Umgebungsluft um Ihr Ein- oder Zweifamilienhaus
                              wirtschaftlich zu heizen!</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="same-height shadowbox-gray shadow-border-black-top">
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <h2>Pellets, Stückholz oder Hackgut</h2>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <h4>Pelletsheizung – Bequemes Heizen</h4>
                            <ul>
                              <li>Wirtschaftlich und komfortabel</li>
                              <li>Heimischer Brennstoff</li>
                              <li>Einfaches Befüllen des Lagerraums mit Tankwagen</li>
                              <li>Geringes Lagerraumvolumen</li>
                            </ul>
                            <h4>Stückholzheizung – Manuell und günstig</h4>
                            <ul>
                              <li>Niedrige Brennstoffkosten</li>
                              <li>Regionale Verfügbarkeit</li>
                              <li>Bis zu 1/2-Meter-Scheitholz</li>
                            </ul>
                            <h4>Hackgutkessel – Günstig und komfortabel</h4>
                            <ul>
                              <li>Vollautomatische und bequeme Wärmeversorgung</li>
                              <li>Belieferung durch heimische Landwirte</li>
                              <li>Wertschöpfung bleibt in der Region</li>
                            </ul>
                            <h4>Kombikessel Stückholz + Pellets – Doppelter Vorteil</h4>
                            <ul>
                              <li>Beruhigend, wenn man flexibel heizen kann</li>
                              <li>Bequem und komfortabel mit Pellets</li>
                              <li>Manuell und günstig mit Stückholz</li>
                            </ul>
                          </div>
                          <div className="col-md-12">
                            <p>Komfortabel und günstig Heizen mit Pellets, Stückholz oder Hackgut. Wussten
                              Sie, dass der Wald genau soviel CO2 zum Wachsen benötigt, wie später beim
                              Verbrennen oder beim Verrotten von Biomasse freigesetzt wird? Es ist unerheblich,
                              ob das Holz verbrannt wird – oder im Wald zu Humus umgewandelt wird! Der
                              Energieträger Holz – in Form von Pellets, Stückholz oder Hackgut – verbrennt
                              im Gegensatz zu fossilen Brennstoffen CO2 neutral. Sie leisten damit einen
                              wesentlichen Beitrag für Klima- und Umweltschutz und sichern ihren Kindern
                              und zukünftigen Generationen eine lebenswerte Zukunft.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="same-height shadowbox-white shadow-border-top">
                        <div className="row">
                          <div className="col-md-12 text-center">
                            <h2>BHKW</h2>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <p>Möchten Sie Energie sparen? Und auf bequeme Art umweltschonend heizen? Dann
                              sollten Sie die investierte Energie mehrfach nutzen: Mit Kraft-Wärme-Kopplung
                              auf Gasbasis wird nur einmal Energie aufgewendet, um sowohl Strom als auch
                              Wärme und warmes Wasser zu erzeugen. Wir zeigen Ihnen, welche enormen ökologischen
                              und ökonomischen Vorteile Kraft-Wärme-Kopplung hat und wie Sie diese energiesparende
                              Technologie ganz einfach in Ihrem Zuhause, Ihrem Mehrfamilien haus oder Ihrem
                              Betrieb einsetzen können: mit einem Familienkraftwerk oder Privatkraftwerk
                              von Vaillant.</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
          <div id="hersteller banner" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-4" description="HTML">
                <div className="hersteller-section">
                  <div className="row">
                    <div className="col-md-12 text-center">
                        <img alt="Vaillant Heizung" className="hersteller" src="files/heizung/hersteller/vaillant.png" />
                                              <img className="hersteller" src="files/heizung/hersteller/solar-focus.png" />                      
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/heizung/Heizung.js